import userType from '../type/personType';
import quoteGQLString from '../util/quoteGQLString';

export default (orgId) => `
    usersByOrg (org: ${quoteGQLString(orgId)}) {
        ${userType()}
    }
`;
